const config = {
  //gmaps_api_key: "AIzaSyAYlJIHAjK8lNKuJFSyaV6dH1gUyJZdGQM"
  gmaps_api_key: "AIzaSyDSyWkEd2JRg1lVQ8kZBrJ_htJwBSL-tCU",
};

export default config;
